import { eq, ord } from 'fp-ts';

export function getNullableEq<T>({ equals }: eq.Eq<T>): eq.Eq<T | null | undefined> {
    return {
        equals: (x, y) => (x != null && y != null && equals(x, y)) || (x == null && y == null),
    };
}

export const getNullableOrd = <T>({ compare }: ord.Ord<T>) =>
    ord.fromCompare<T | null | undefined>((x, y) => {
        if (x == null) return -1;
        if (y == null) return 1;
        return compare(x, y);
    });
